module.exports = __webpack_public_path__ + "static/media/migrate-subscription.c88bb183.svg";